(() => {
  const MAX_RETRIES = 3;
  const RETRY_DELAY_MS = 300;

  const state = {
    activeOverlays: 0,
  };

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const getChatplusView = async () => {
    for (let i = 0; i < MAX_RETRIES; i++) {
      const el = document.getElementById('chatplusview');
      if (el) return el;
      await wait(RETRY_DELAY_MS);
    }
    return document.getElementById('chatplusview') || null;
  };

  const hide = async () => {
    state.activeOverlays += 1;
    const view = await getChatplusView();
    if (!view) return;
    view.style.display = 'none';
  };

  const show = async () => {
    state.activeOverlays = Math.max(0, state.activeOverlays - 1);
    if (state.activeOverlays > 0) return;

    const view = await getChatplusView();
    if (!view) return;
    view.style.display = 'block';
  };

  window.ChatPlusControl = {
    hide,
    show,
  };
})();
